export default {
  public: "#1e88e5",
  chat: "#66bb6a",
  telephony: "#4db6ac",
  remoteAccess: "#1e88e5",
  email: "#1e88e5",
  positive: "#50c86e",
  negative: "#ef5350",
  grey: "#bebebe",
  white: "#fff",
  brownishGrey: "#5f5f5f",
  blue: "#0288d1",
  defaultHeader: "#455a64",
  npsZero: "#c62828",
  npsOne: "#e53935",
  npsTwo: "#ef5350",
  npsThree: "#ff7043",
  npsFour: "#ff8426",
  npsFive: "#ffAD08",
  npsSix: "#ffcb21",
  npsSeven: "#c0d453",
  npsEight: "#9ccc65",
  npsNine: "#4fb054",
  npsTen: "#36963b",
  feedback: "#81c784"
};
